import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from '@core/api/baseQuery';
import type { PaginatedResponse } from '@core/types/api';

export interface AuditResource {
  uuid: string;
  created_at: string;
  action: string;
  resource_type: string;
  resource_uuid: string | null;
  resource_label: string;
  company_uuid: string | null;
  company_label: string;
  insurer_uuid: string | null;
  insurer_label: string;
  portal_uuid: string | null;
  portal_label: string;
  result: string;
}
export interface AuditOperation extends AuditResource {
  correlation: string;
  actor_uuid: string | null;
  actor_label: string;
  origin: string;
  job_uuid: string | null;
  entry_count: number;
  change_counts: Partial<Record<'create' | 'update' | 'delete', number>>;
}
export interface AuditChange {
  before?: unknown;
  after?: unknown;
  redacted?: boolean;
}
export interface AuditEntry extends AuditResource {
  kind: string;
  changes: Record<string, AuditChange>;
  attempt: number;
  error_code: string;
}
export type AuditFacets = Record<string, { value: string; label: string }[]>;

export const auditApi = createApi({
  reducerPath: 'auditApi',
  baseQuery,
  refetchOnMountOrArgChange: true,
  endpoints: (builder) => ({
    listAuditOperations: builder.query<PaginatedResponse<AuditOperation>, string>({
      query: (query) => `/api/audit/operations/?${query}`,
    }),
    getAuditOperation: builder.query<AuditOperation, string>({
      query: (uuid) => `/api/audit/operations/${uuid}/`,
    }),
    listAuditEntries: builder.query<PaginatedResponse<AuditEntry>, { uuid: string; page: number; search?: string; kind?: string }>({
      query: ({ uuid, page, search, kind }) => ({ url: `/api/audit/operations/${uuid}/entries/`, params: { page, search, kind } }),
    }),
    getAuditFacets: builder.query<AuditFacets, void>({
      query: () => '/api/audit/facets/',
    }),
  }),
});
export const {
  useListAuditOperationsQuery, useGetAuditOperationQuery, useListAuditEntriesQuery, useGetAuditFacetsQuery,
} = auditApi;
